import React from 'react'
import { string, number, bool, node, func, oneOf, oneOfType, object } from 'prop-types'
import styled, { css } from 'styled-components'

import { orange, white, lightBlue, semiDarkBlue } from '../colors'

const StyledButton = styled.button`
  width: 100%;
  max-width: ${({ width }) => `${width}px`};
  min-height: ${({ height }) => `${height}px`};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: ${white};
  font-size: 16px;
  text-transform: uppercase;
  border: 0;
  outline: 0;
  cursor: pointer;
  background-color: ${orange};

  :hover:not(:disabled) {
    background-color: #ec7b47;
  }

  :active:not(:disabled) {
    background-color: #db703e;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ type }) =>
    type === 'default' &&
    css`
      opacity: 0.6;
      color: ${semiDarkBlue};
      background-color: ${lightBlue};

      :hover:not(:disabled) {
        background-color: #bcd4e4;
      }

      :active:not(:disabled) {
        background-color: #afcadc;
      }
    `}
`

const Button = ({
  label,
  icon,
  disabled,
  onClick,
  className,
  style,
  type,
  width = 175,
  height = 54
}) => (
  <StyledButton
    className={className}
    style={style}
    onClick={onClick}
    type={type}
    disabled={disabled}
    width={width}
    height={height}
  >
    {icon}
    {label}
  </StyledButton>
)

Button.propTypes = {
  label: oneOfType([string, object]),
  icon: node,
  disabled: bool,
  className: string,
  type: oneOf(['default']),
  width: number,
  height: number,
  onClick: func,
  style: object
}

export default Button
